const getStylesToUpdate = ({
  backgroundImage
}) => {
  if (!backgroundImage) return {};
  return {
    backgroundImage: `url("${backgroundImage}")`
  };
};
export default getStylesToUpdate;
//# sourceMappingURL=get-styles-to-update.js.map